// src/components/PropertyFormSections/FinancialDetails.js
import React from 'react';

const FinancialDetails = ({ formData, handleInputChange }) => {
    return (
        <>
            {/* Price */}
            <div className="mb-4">
                <label className="block font-bold">Price</label>
                <input
                    type="text"
                    name="price"
                    value={formData.price}
                    onChange={handleInputChange}
                    placeholder="e.g., ₹5 Lac /month or ₹10 Cr"
                    className="border p-2 w-full"
                    required
                />
            </div>

            {/* Area fields */}
            <div className="grid grid-cols-2 gap-2">
                <div className="mb-4">
                    <label className="block font-bold">Carpet Area</label>
                    <input
                        type="text"
                        name="carpet_area"
                        value={formData.carpet_area}
                        onChange={handleInputChange}
                        placeholder="e.g., 5130 sq.ft."
                        className="border p-2 w-full"
                    />
                </div>
                <div className="mb-4">
                    <label className="block font-bold">Leasable Area</label>
                    <input
                        type="text"
                        name="leasable_area"
                        value={formData.leasable_area}
                        onChange={handleInputChange}
                        placeholder="e.g., 8000 sq.ft."
                        className="border p-2 w-full"
                    />
                </div>
            </div>

            {/* Car Parks & Furnishing */}
            <div className="grid grid-cols-2 gap-2">
                <div className="mb-4">
                    <label className="block font-bold">Car Parks</label>
                    <input
                        type="number"
                        name="car_parks"
                        value={formData.car_parks}
                        onChange={handleInputChange}
                        placeholder="e.g., 8"
                        className="border p-2 w-full"
                        min="0"
                    />
                </div>
                <div className="mb-4">
                    <label className="block font-bold">Furnishing</label>
                    <select
                        name="furnishing"
                        value={formData.furnishing}
                        onChange={handleInputChange}
                        className="border p-2 w-full"
                    >
                        <option value="N/A">N/A</option>
                        <option value="Furnished">Furnished</option>
                        <option value="Semi-Furnished">Semi-Furnished</option>
                        <option value="Unfurnished">Unfurnished</option>
                        <option value="Bare shell">Bare shell</option>
                    </select>
                </div>
            </div>
        </>
    );
};

export default FinancialDetails;